<script>
import HarnessSelectionStats from '../FormGuideSelectionStats/HarnessSelectionStats.vue';
import EventSelectionRowDesktop from './EventSelectionRowDesktop.vue';
import EventSelectionRowMobile from './mobile/EventSelectionRowMobile.vue';
import SparkLine from '../SparkLine/SparkLine.vue';
import BestOdds from '../BestOdds/BestOdds.vue';
import AccordionTransition from './common/AccordionTransition.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'EventSelectionRow',
  components: {
    EventSelectionRowDesktop,
    EventSelectionRowMobile,
    HarnessSelectionStats,
    SparkLine,
    BestOdds,
    AccordionTransition,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    selectionData: {
      type: Object,
      required: true,
    },
    odds: {
      type: Object,
      required: true,
    },
    flucs: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    liveBets: {
      type: Array,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
    isAbandoned: {
      type: Boolean,
      required: true,
    },
    isFormGuidePage: {
      type: Boolean,
      default: true,
    },
    conversionBookmaker: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDetailsActive: false,
      isShortListed: false,
      isBlackbooked: false,
      addedGearChanges: '',
      removedGearChanges: '',
    };
  },
  computed: {
    ...mapGetters({
      raceType: 'FormGuideEventCard/getRaceType',
      eventData: 'FormGuideEventCard/getEventData',
    }),
    competitor() {
      return this.selectionData.competitor || {};
    },
    jockey() {
      return this.selectionData.jockey || {};
    },
    trainer() {
      return this.selectionData.trainer || {};
    },
    competitorString() {
      const { selectionData, competitor } = this;
      return selectionData && competitor
        ? `${selectionData.competitor_number}. ${competitor.name} (${selectionData.barrier_number})`
        : '';
    },
    jockeyName() {
      const { jockey } = this;
      const { first_names, last_name, short_name } = jockey;
      return first_names && last_name ? `${first_names} ${last_name}` : `${short_name}`;
    },
    trainerName() {
      const { trainer } = this;
      const { first_names, last_name, short_name } = trainer;
      return first_names && last_name ? `${first_names} ${last_name}` : `${short_name}`;
    },
    expandAllActive() {
      return this.filters.expandAll;
    },
    showBetsFlucsDetails() {
      const { flucs, liveBets, selectionData } = this;
      const { showFlucs, showBets } = this.filters;
      return (showBets && liveBets.length > 0) || (showFlucs && flucs.length > 0 && !selectionData.isScratched);
    },
    isHarness() {
      return this.raceType == 'harness';
    },
    isResulted() {
      return this.results.length > 0;
    },
    getSelectionResult() {
      const { results, isResulted, selectionData } = this;
      if (isResulted) {
        const result = results.filter(a => a.competitor_id === selectionData.competitor_id);
        return result.length > 0 ? result[0].finish_position : '';
      }
      return '';
    },
    selectionDataFlucs() {
      return this.flucs.map(item => {
        return Object.values(item).reverse();
      });
    },
    selectionStats() {
      return this.selectionData ? this.selectionData.stats : [];
    },
  },
  mounted() {
    this.setGearChanges();
  },
  methods: {
    setGearChanges() {
      // filter tips and add to added/removed gear changes strings
      try {
        if (this.selectionData.gear_changes && this.selectionData.gear_changes.length > 0) {
          const addedFiltered = this.selectionData.gear_changes.filter(item => {
            if (item.status === 1) {
              return item.gear_name;
            }
          });

          const addedArray = addedFiltered.map(e => {
            return e.gear_name;
          });

          const removedFiltered = this.selectionData.gear_changes.filter(item => {
            if (item.status === 0) {
              return item.gear_name;
            }
          });

          const removedArray = removedFiltered.map(e => {
            return e.gear_name;
          });

          this.addedGearChanges = addedArray.length > 0 ? ` ${addedArray.join(', ')}` : '';
          this.removedGearChanges = removedArray.length > 0 ? `${removedArray.join(', ')}` : '';
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <div
    :class="{'selection-scratched': selectionData.isScratched, 
             'has-results': isResulted, 
             'selection-resulted': getSelectionResult > 0,
             'is-abandoned': isAbandoned }"
    class="event-selection-row-container"
  >
    <!-- mobile -->
    <div v-if="isMobile" class="event-selection-row selection-row-mobile">
      <EventSelectionRowMobile
        :selection-data="selectionData"
        :selection-flucs="flucs"
        :selection-live-bets="liveBets"
        :competitor="competitor"
        :competitor-string="competitorString"
        :jockey-name="jockeyName"
        :trainer-name="trainerName"
        :result="getSelectionResult"
        :odds="odds"
        :is-harness="isHarness"
        :is-scratched="selectionData.isScratched"
        :is-resulted="isResulted"
        :results="results"
        :show-bets-flucs="showBetsFlucsDetails"
        :filters="filters"
        :is-form-guide-page="isFormGuidePage"
        :conversion-bookmaker="conversionBookmaker"
      />
    </div>

    <!-- desktop -->
    <template v-else>
      <EventSelectionRowDesktop
        :headers="headers"
        :selection-data="selectionData"
        :selection-stats="selectionStats"
        :selection-flucs="flucs"
        :selection-live-bets="liveBets"
        :result="getSelectionResult"
        :competitor="competitor"
        :competitor-string="competitorString"
        :jockey-name="jockeyName"
        :trainer-name="trainerName"
        :odds="odds"
        :is-scratched="selectionData.isScratched"
        :is-harness="isHarness"
        :show-bets-flucs="showBetsFlucsDetails"
        :expand-all-active="expandAllActive"
        :added-gear-changes="addedGearChanges"
        :removed-gear-changes="removedGearChanges"
        :filters="filters"
        :is-form-guide-page="isFormGuidePage"
        :conversion-bookmaker="conversionBookmaker"
      />
    </template>
  </div>
</template>
